import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Marker, Popup, useMapEvents } from 'react-leaflet';
import { IPosition } from './IPosition';

interface IProps {
  position: IPosition;
  setPosition: React.Dispatch<React.SetStateAction<IPosition>>;
  setStreet: React.Dispatch<React.SetStateAction<string>>;
  setStreetNr: React.Dispatch<React.SetStateAction<string>>;
  setPostcode: React.Dispatch<React.SetStateAction<string>>;
  setCity: React.Dispatch<React.SetStateAction<string>>;
  setLat: React.Dispatch<React.SetStateAction<number>>;
  setLong: React.Dispatch<React.SetStateAction<number>>;
}

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

export const DraggableMarker: React.FC<IProps> = ({
  position,
  setPosition,
  setStreet,
  setStreetNr,
  setPostcode,
  setCity,
  setLat,
  setLong,
}) => {
  const [draggable] = useState(true);
  const markerRef = useRef<L.Marker | null>(null);

  const _ = useMapEvents({
    click: e => {
      setPosition({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });

  useEffect(() => {
    setLat(position.lat);
    setLong(position.lng);

    fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${position.lat}&lon=${position.lng}&format=json`,
      {
        headers: {
          'User-Agent': 'DiNoPublic',
        },
      }
    )
      .then(res => res.json())
      .then(res => {
        setStreet(res.address.road || '');
        setStreetNr(res.address.house_number || '');
        setPostcode(res.address.postcode);
        setPostcode(res.address.postcode);

        if ('town' in res.address) {
          setCity(res.address.town);
        } else {
          setCity(res.address.city);
        }
      });
  }, [position]);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker !== null) {
          setPosition(marker.getLatLng()!);
        }
      },
    }),
    []
  );

  return (
    <Marker
      draggable={draggable}
      eventHandlers={eventHandlers}
      position={position}
      ref={markerRef}
    >
      <Popup minWidth={90}>
        <>Sie können den Markierer auf die gewünschte Fläche bewegen</>
      </Popup>
    </Marker>
  );
};
